<template lang="pug">
.novelty-data-close(@click.stop="")
  shActionButton(
    v-if="canClose"
    :action="closeNovelty"
    text="Cerrar datos"
    textRunning="Cerrando"
    :normalColor="true"
    :textConfirmation="closeConfirmation"
    width="100%"
  )
</template>

<script>
import { mapActions } from 'vuex'
import shActionButton from '@/components/elements/ActionButton.vue'
import { canCloseDataNovelty } from '@/helpers/orderNovelty'

export default {
  name: 'NoveltyDataClose',

  components: { shActionButton },

  props: {
    order: {
      type: Object,
      required: true
    }
  },

  computed: {
    canClose () {
      return canCloseDataNovelty(this.order)
    },

    closeConfirmation () {
      return `Se cerrarán los datos de la orden ${this.order.order}`
    }
  },

  methods: {
    ...mapActions('orderNovelty', ['closeDataNoveltyOrder']),

    async closeNovelty () {
      const result = await this.closeDataNoveltyOrder(this.order.order)

      if (result && result.success) {
        this.$emit('closed')
      }

      return true
    }
  }
}
</script>

<style lang="stylus" scoped>
.novelty-data-close
  display flex
  justify-content flex-end
  width 100%
  min-width 0

  >>> .button-action-container
    width 100%
</style>



// WEBPACK FOOTER //
// src/components/elements/order/NoveltyDataClose.vue